@if (!useAllButtons) {
    <div class="date-button-picker">
        <div class="dropdown align-self-center">
            <select
                #yearSelect
                class="btn btn-secondary dropdown-toggle"
                (change)="changeYear(yearSelect.value)"
                ngDefaultControl
                [(ngModel)]="year" 
                [ngModelOptions]="{ standalone: true }"            
            >
                @for (y of years; track y) {
                    <option     
                        class="dropdown-item"    
                        [value]="y"             
                    >{{ y }}</option>
                }
            </select>
        </div>

        <div class="dropdown align-self-center">
            <select
                #monthSelect
                class="btn btn-secondary dropdown-toggle"
                (change)="changeMonth(monthSelect.value)"
                ngDefaultControl
                [(ngModel)]="monthInt" 
                [ngModelOptions]="{ standalone: true }"            
            >
                @for (m of months; track m) {
                    <option
                        class="dropdown-item"   
                        [value]="m[0]"               
                    >{{ m[1] }}</option>
                }
            </select>
        </div>

        <div class="dropdown align-self-center">
            @if (
                is31Days 
                && !isAbrreviatedDays
            ) {
                <select
                    #daySelect
                    class="btn btn-secondary dropdown-toggle"
                    (change)="changeDay(daySelect.value)"
                    ngDefaultControl
                    [(ngModel)]="day" 
                    [ngModelOptions]="{ standalone: true }"            
                >
                    @for (d of days31; track d) {
                        <option
                            class="dropdown-item" 
                            [value]="d"
                        >{{ d }}</option>
                    }
                </select>
            }

            @if (
                is30Days 
                && !isAbrreviatedDays
            ) {
                <select
                    #daySelect
                    class="btn btn-secondary dropdown-toggle"
                    (change)="changeDay(daySelect.value)"
                    ngDefaultControl
                    [(ngModel)]="day" 
                    [ngModelOptions]="{ standalone: true }"
                >
                    @for (d of days30; track d) {
                        <option
                            class="dropdown-item" 
                            [value]="d"
                        >{{ d }}</option>
                    }
                </select>
            }

            @if (
                is29Days 
                && !isAbrreviatedDays
            ) {
                <select
                    #daySelect
                    class="btn btn-secondary dropdown-toggle"
                    (change)="changeDay(daySelect.value)"
                    ngDefaultControl
                    [(ngModel)]="day" 
                    [ngModelOptions]="{ standalone: true }"
                >
                    @for (d of days29; track d) {
                        <option
                            class="dropdown-item" 
                            [value]="d"
                        >{{ d }}</option>
                    }            
                </select>
            }

            @if (
                is28Days 
                && !isAbrreviatedDays
            ) {
                <select
                    #daySelect
                    class="btn btn-secondary dropdown-toggle"
                    (change)="changeDay(daySelect.value)"
                    ngDefaultControl
                    [(ngModel)]="day" 
                    [ngModelOptions]="{ standalone: true }"
                >
                    @for (d of days28; track d) {
                        <option
                            class="dropdown-item" 
                            [value]="d"
                        >{{ d }}</option>
                    }
                </select>
            }

            @if (isAbrreviatedDays) {
                <select
                    #daySelect
                    class="btn btn-secondary dropdown-toggle"
                    (change)="changeDay(daySelect.value)"
                    ngDefaultControl
                    [(ngModel)]="day" 
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="Day"
                >
                    @for (d of abbrDays; track d) {
                        <option
                            class="dropdown-item"  
                            [value]="d"               
                        >{{ d }}</option>
                    }
                </select>
            }
        </div>
    </div>
} @else {
    <div class="date-button-picker">
        @if (isYearShowing) {
            @for (y of years; track y) {
                <div>
                    <button
                        type="button"
                        class="btn btn-view btn-lg"
                        [value]="y"
                        (click)="buttonYear(y)"
                    >{{ y }}</button>
                </div>
            }   
        }

        @if (isMonthShowing) {
            @for (m of months; track m) {
                <div>
                    <button
                        type="button"
                        class="btn btn-view btn-lg"
                        [value]="m[0]"
                        (click)="buttonMonth(m[0])"
                    >{{ m[1] }}</button>
                </div>
            }   
        }

        @if (
            isDayShowing 
            && is31Days 
            && !isAbrreviatedDays
        ) {
            @for (d of days31; track d) {
                <div>
                    <button
                        type="button"
                        class="btn btn-view btn-lg"
                        [value]="d"
                        (click)="buttonDay(d); isDayShowing = false;"
                    >{{ d }}</button>
                </div>
            }  
        }

        @if (
            isDayShowing 
            && is30Days 
            && !isAbrreviatedDays
        ) {
            @for (d of days30; track d) {
                <div>
                    <button
                        type="button"
                        class="btn btn-view btn-lg"
                        [value]="d"
                        (click)="buttonDay(d); isDayShowing = false;"
                    >{{ d }}</button>
                </div>
            }  
        }

        @if (
            isDayShowing 
            && is29Days 
            && !isAbrreviatedDays
        ) {
            @for (d of days29; track d) {
                <div>
                    <button
                        type="button"
                        class="btn btn-view btn-lg"
                        [value]="d"
                        (click)="buttonDay(d); isDayShowing = false;"
                    >{{ d }}</button>
                </div>
            }  
        }

        @if (
            isDayShowing 
            && is28Days 
            && !isAbrreviatedDays
        ) {
            @for (d of days28; track d) {
                <div>
                    <button
                        type="button"
                        class="btn btn-view btn-lg"
                        [value]="d"
                        (click)="buttonDay(d); isDayShowing = false;"
                    >{{ d }}</button>
                </div>
            }  
        }
        
        @if (
            isDayShowing 
            && isAbrreviatedDays
        ) {
            @for (d of abbrDays; track d) {
                <div>
                    <button
                        type="button"
                        class="btn btn-view btn-lg"
                        [value]="d"
                        (click)="buttonDay(d);"
                    >{{ d }}</button>
                </div>
            }  
        }

        @if (
            !isYearShowing 
            && !isMonthShowing 
            && !isDayShowing
        ) {
            <div>
                <label>{{ modelDate | date:"MM/dd/yyyy" }}</label>
                <fa-icon 
                    [icon]="faIconName.faTrashCan" 
                    class="trash-can" 
                    (click)="clearButtonDate()"
                ></fa-icon>
            </div>
        }
    </div>
}